export var OrganizationRoleGrantTargetKind;
(function (OrganizationRoleGrantTargetKind) {
    OrganizationRoleGrantTargetKind["ORGANIZATION_ROLE_GRANT_TARGET_KIND_ORG"] = "ORG";
    OrganizationRoleGrantTargetKind["ORGANIZATION_ROLE_GRANT_TARGET_KIND_ACCOUNT"] = "ACCOUNT";
})(OrganizationRoleGrantTargetKind || (OrganizationRoleGrantTargetKind = {}));
